// extracted by mini-css-extract-plugin
module.exports = {"downloadLink":"noteRow_downloadLink__2CeN1"};